import { $sceneMap, $sceneMapApi, $tourDataApi } from '@stores/dataStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import { $loadedId } from '@stores/loadedStore';
import { FeatureType, type GeneralID } from '@types';
import { createEvent, sample } from 'effector';
import { getHotspotTitleId } from '../../hotspot';
import { isSTMarkerScene } from '../../sandTable/utils/markerTypeCheck';

export const renameScene = createEvent<{
  sceneId: GeneralID;
  name: string;
  renameHotspot: boolean;
  renameSandTable: boolean;
}>();

sample({
  source: { sceneMap: $sceneMap, loadedId: $loadedId },
  clock: renameScene,
  fn: (source, clock) => ({ ...source, ...clock }),
}).watch(
  ({ sceneMap, loadedId, sceneId, name, renameHotspot, renameSandTable }) => {
    // 重命名场景
    $sceneMapApi.update((draft) => {
      draft.get(sceneId)!.name = name;
    });
    // 重命名热点
    if (renameHotspot) {
      [...sceneMap.values()].forEach((scene) => {
        if (!scene.hotspot) return;
        scene.hotspot.forEach((spot, i) => {
          if (
            spot.data.code === FeatureType.scene &&
            spot.data.sceneId === sceneId
          ) {
            $sceneMapApi.update((draft) => {
              draft.get(scene.id)!.hotspot![i].title = name;
            });
            if (loadedId === scene.id) {
              const titleId = getHotspotTitleId(spot.id, spot.icon.type);
              MainPlayer.get()?.updateDivHotspot({
                ...spot,
                id: titleId!,
                title: name,
              });
            }
          }
        });
      });
    }
    // 重命名沙盘
    if (renameSandTable) {
      $tourDataApi.update((draft) => {
        draft.sandBox ??= [];
        draft.sandBox.forEach((st) => {
          st.markers.forEach((m) => {
            if (isSTMarkerScene(m) && m.data.sceneId === sceneId) {
              m.title = name;
            }
          });
        });
      });
    }
  }
);
